<button
    *ngIf="href === null"
    [disabled]="disabled"
    [ngClass]="
        styleMap[style] +
        ' ' +
        (loading ? 'loading' : '') +
        ' ' +
        (arrowAnimate ? 'arrow-button' : '') +
        ' ' +
        btnClass +
        ' ' +
        (size === 'normal' ? '' : size === 'small' ? 'btn-sm' : 'btn-lg')
    "
    [type]="type"
    class="btn"
    (click)="handleClick($event)"
    (keydown)="handleKeyDown($event)"
>
    <ng-template [ngTemplateOutlet]="contentButton"></ng-template>
</button>
<a
    [attr.url-rendered]="href"
    *ngIf="href !== null && isValidUrl()"
    [tabindex]="tabIndex"
    [ngClass]="
        styleMap[style] +
        ' ' +
        (loading ? 'loading' : '') +
        ' ' +
        (arrowAnimate ? 'arrow-button' : '') +
        '' +
        btnClass
    "
    class="btn d-flex align-items-center"
    [target]="target"
    [routerLink]="href"
    [fragment]="fragment"
>
    <ng-template [ngTemplateOutlet]="contentButton"></ng-template>
</a>
<a
    [attr.url-rendered]="href"
    *ngIf="href !== null && !isValidUrl()"
    [tabindex]="tabIndex"
    [ngClass]="
        styleMap[style] +
        ' ' +
        (loading ? 'loading' : '') +
        ' ' +
        (arrowAnimate ? 'arrow-button' : '') +
        '' +
        btnClass
    "
    class="btn d-flex align-items-center"
    [target]="target"
    [href]="href"
>
    <ng-template [ngTemplateOutlet]="contentButton"></ng-template>
</a>

<ng-template #contentButton>
    <img
        [style.margin-right.px]="onlyIcon ? '0' : undefined"
        [ngClass]="onlyIcon ? 'only-icon' : ''"
        *ngIf="icon !== null && iconPosition === 'left'"
        class="btn-icon left"
        [src]="'images/' + icon + '.' + iconFormat | cdn"
        alt="icon button"
    />
    <ng-content *ngIf="!onlyIcon"></ng-content>
    <img
        [style.margin-left.px]="onlyIcon ? '0' : undefined"
        [ngClass]="onlyIcon ? 'only-icon' : ''"
        *ngIf="icon !== null && iconPosition === 'right' && !arrowAnimate"
        class="btn-icon right"
        [src]="'images/' + icon + '.' + iconFormat | cdn"
        alt="icon button"
    />
    <span *ngIf="arrowAnimate" class="arrow"></span>
    <img *ngIf="loading" class="points" alt="" />
    <div *ngIf="underline" class="underline"></div>
</ng-template>
